
@if (FC) {
  <div>
    @for (option of options; track option) {
      <label
        for="{{ option.value }}"
        class="option surface-border border-1 p-3 m-0 flex align-items-center gap-3 cursor-pointer"
        [class.selected-option]="FC.value === option.value"
        [class.border-round-top]="$first"
        [class.border-round-bottom]="$last"
        [attr.data-test]="'event-type-radio-input-' + option.value"
      >
        <p-radioButton inputId="{{ option.value }}" [formControl]="FC" [value]="option.value"></p-radioButton>
        <div>
          <div class="font-medium mb-1 text-gray-900">{{ option.label | translate }}</div>
          <span class="text-sm text-gray-600">
            {{ option.description | translate }}
          </span>
        </div>
      </label>
    }
    <!-- <label for="{{EventType.SINGLE_SG}}" class="surface-border border-1 p-3 border-round-top flex align-items-center gap-3 cursor-pointer">
        <p-radioButton inputId="{{EventType.SINGLE_SG}}" formControlName="format" (onClick)="onSelect($event)" [value]="EventType.SINGLE_SG"></p-radioButton>
        <div>
            <div class="font-medium mb-1">{{ 'admin.event-type-radio-input.SINGLE_SG.title' | translate }}</div>
            <span class="text-sm">
              {{ 'admin.event-type-radio-input.SINGLE_SG.description' | translate }}
            </span>
        </div>
    </label> -->
    <!-- <label for="{{EventFormat.SEMESTER}}" class="surface-border border-1 border-round-top p-3 flex align-items-center gap-3 cursor-pointer">
      <p-radioButton inputId="{{EventFormat.SEMESTER}}" formControlName="format" (onClick)="onSelect($event)"  [value]="EventFormat.SEMESTER"></p-radioButton>
      <div>
            <div class="font-medium mb-1">{{ 'admin.event-type-radio-input.SEMESTER.title' | translate }}</div>
            <span class="text-sm" >
              {{ 'admin.event-type-radio-input.SEMESTER.description' | translate }}
            </span>
        </div>
    </label>
    <label for="{{EventFormat.CONFERENCE}}" class="surface-border border-1 border-top-none p-3 flex align-items-center gap-3 cursor-pointer">
      <p-radioButton inputId="{{EventFormat.CONFERENCE}}" formControlName="format" (onClick)="onSelect($event)"  [value]="EventFormat.CONFERENCE"></p-radioButton>
      <div>
            <div class="font-medium mb-1">{{ 'admin.event-type-radio-input.CONFERENCE.title' | translate }}</div>
            <span class="text-sm" >
              {{ 'admin.event-type-radio-input.CONFERENCE.description' | translate }}
            </span>
        </div>
    </label>
    <label for="{{EventFormat.CAMP}}" class="surface-border border-1 border-top-none p-3 flex align-items-center gap-3 cursor-pointer">
      <p-radioButton inputId="{{EventFormat.CAMP}}" formControlName="format" (onClick)="onSelect($event)"  [value]="EventFormat.CAMP"></p-radioButton>
      <div>
            <div class="font-medium mb-1">{{ 'admin.event-type-radio-input.CAMP.title' | translate }}</div>
            <span class="text-sm" >
              {{ 'admin.event-type-radio-input.CAMP.description' | translate }}
            </span>
        </div>
    </label>
    <label for="{{EventFormat.FESTIVAL}}" class="surface-border border-1 border-top-none p-3 flex align-items-center gap-3 cursor-pointer">
      <p-radioButton inputId="{{EventFormat.FESTIVAL}}" formControlName="format" (onClick)="onSelect($event)"  [value]="EventFormat.FESTIVAL"></p-radioButton>
      <div>
            <div class="font-medium mb-1">{{ 'admin.event-type-radio-input.FESTIVAL.title' | translate }}</div>
            <span class="text-sm" >
              {{ 'admin.event-type-radio-input.FESTIVAL.description' | translate }}
            </span>
        </div>
    </label>
    <label for="{{EventFormat.OFFER}}" class="surface-border border-1 border-top-none p-3 flex align-items-center gap-3 cursor-pointer">
      <p-radioButton inputId="{{EventFormat.OFFER}}" formControlName="format" (onClick)="onSelect($event)"  [value]="EventFormat.OFFER"></p-radioButton>
      <div>
            <div class="font-medium mb-1">{{ 'admin.event-type-radio-input.OFFER.title' | translate }}</div>
            <span class="text-sm" >
              {{ 'admin.event-type-radio-input.OFFER.description' | translate }}
            </span>
        </div>
    </label>
    <label for="{{EventFormat.EVENT}}" class="surface-border border-1 border-top-none p-3 border-round-bottom flex align-items-center gap-3 cursor-pointer">
      <p-radioButton inputId="{{EventFormat.EVENT}}" formControlName="format" (onClick)="onSelect($event)"  [value]="EventFormat.EVENT"></p-radioButton>
      <div>
            <div class="font-medium mb-1">{{ 'admin.event-type-radio-input.EVENT.title' | translate }}</div>
            <span class="text-sm" >
              {{ 'admin.event-type-radio-input.EVENT.description' | translate }}
            </span>
        </div>
    </label> -->
  </div>

}
